import { createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";

const initialAccountsState = {
    entities: [],
    totalCount: null,
    listLoading: false,
    actionsLoading: false,
    message: {
        error: null,
        success: null,
        completed: null,
    },
};

export const callTypes = {
    list: "list",
    action: "action",
};

export const ChartsOfAccountsSlice = createSlice({
    name: "chartsOfAccounts",
    initialState: initialAccountsState,
    reducers: {
        catchError: (state, action) => {
            let error =
                action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
            if (error.constructor.name === "Object") {
                let temp = [];
                for (let [k, v] of Object.entries(error)) {
                    temp.push(`${k}->${v}`);
                }
                error = temp;
            }
            state.message.error = error;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.message.success = null;
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },

        // accounts fetched from api
        AccountsFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        accountCreated: (state, action) => {
            const { message, entity } = action.payload;
            state.actionsLoading = false;
            state.error = null;
            state.entities.unshift(entity);
            state.totalCount = state.totalCount + 1;
            state.message.success = message;
        },
        accountUpdated: (state, action) => {
            const { message, entity } = action.payload;
            state.actionsLoading = false;
            state.error = null;
            // Update the account in the entities array
            const accountIndex = state.entities.findIndex(acc => acc.id === entity.id);
            if (accountIndex !== -1) {
                state.entities[accountIndex] = entity;
            }
            state.message.success = message;
        },
        accountStatusUpdated: (state, action) => {
            const { accountId, isActive } = action.payload;
            state.actionsLoading = false;
            state.error = null;
            // Update the account status in the entities array
            const accountIndex = state.entities.findIndex(acc => acc.id === accountId);
            if (accountIndex !== -1) {
                state.entities[accountIndex].is_active = isActive;
            }
            state.message.success = `Account ${isActive ? 'activated' : 'deactivated'} successfully`;
        },
    },
});
